import {
	createBrowserNavigationUrl,
	Navigation,
	route
} from "client/Navigation";
import { OverviewPageQueryParams, OverviewPageRouteParams } from "./OverviewPage";
import { DetailsPageQueryParameters, DetailsPageRouteParameters } from "./DetailsPage";
import { AddressBookContactSource } from "./Overview/Overview";
import {
	base64UrlDecode,
	base64UrlEncode,
	ensureNotNil,
	isNil,
	isNotNil
} from "client/Misc/utils";
import { ContactSource } from "client/Api/Email/contacts";
import { SourceSelectorValue } from "./SourceSelector";
import { never } from "client_legacy/ndaw/errors";

export const addressBookRouting = {
	autoSelectSource: "/AddressBook",
	overview: route<OverviewPageRouteParams, OverviewPageQueryParams>`/AddressBook/${"source"}`,
	details: route<DetailsPageRouteParameters, DetailsPageQueryParameters>`/AddressBook/${"source"}/${"id"}`
};

export function getAddressBookUrl(value?: SourceSelectorValue): string {
	let navigation: string | Navigation = addressBookRouting.autoSelectSource;

	if (isNotNil(value)) {
		navigation = getAddressBookNavigationForOverview(value);
	}

	return createBrowserNavigationUrl(navigation);
}

export function getAddressBookNavigationForOverview(
	value: SourceSelectorValue
): Navigation {
	const { filter } = value;

	return addressBookRouting.overview({
		routeParams: {
			source: ensureNotNil(
				convertToSourcePath(value.source)
			)
		},
		queryParams: {
			department: filter?.kind === "department"
				? filter.value
				: undefined,
			officeLocation: filter?.kind === "officeLocation"
				? filter.value
				: undefined
		}
	});
}

export function convertToSourcePath(source: AddressBookContactSource | undefined): string | undefined {
	return isNotNil(source)
		? sourceMapping.get(source)
		: undefined;
}

export function tryParseContactSource(pathSource: string | nil): TryResult<AddressBookContactSource> {
	if (isNil(pathSource)) {
		return {
			wasSuccessful: false
		};
	}

	const mappedSource: AddressBookContactSource | undefined = [...sourceMapping.entries()]
		.find(
			([_, value]) => value.toUpperCase() === pathSource.toUpperCase()
		)
		?.[0];

	if (isNotNil(mappedSource)) {
		return {
			wasSuccessful: true,
			result: mappedSource
		};
	}

	return {
		wasSuccessful: false
	};
}

const sourceMapping = new Map<AddressBookContactSource, string>([
	[ContactSource.Personal, "personal"],
	[ContactSource.Gal, "gal"],
	[ContactSource.Workspace, "workspace"]
]);

// NOTE This function does not produce url safe string, it fixes the issues iis have with some character sequences
export function encodeIdForRouting(source: AddressBookContactSource, id: string): string {
	switch (source) {
		case ContactSource.Workspace:
			return id;
		case ContactSource.Personal:
		case ContactSource.Gal:
			return base64UrlEncode(id, true);
		default:
			never(source);
	}
}

export function decodeIdFromRouting(source: AddressBookContactSource, id: string): string {
	switch (source) {
		case ContactSource.Workspace:
			return id;
		case ContactSource.Personal:
		case ContactSource.Gal:
			return base64UrlDecode(id);
		default:
			never(source);
	}
}